// AUTO-GENERATED by scripts/generate-performance-indexes.mjs. Do not edit manually.
export const homepageFirmData = [
  {
    "id": "alpha-capital",
    "name": "Alpha Capital Group",
    "logo": "/assets/logos/alpha-capital/logo.svg",
    "affiliateLink": "/go/alpha-capital",
    "features": {
      "maxFunding": 400000,
      "profitSplit": 90,
      "profitSplitNote": "Standard 80%; up to 90% where the add-on is offered, while Alpha Direct starts at 90%",
      "platforms": [
        "mt5",
        "ctrader",
        "dxtrade",
        "tradelocker"
      ],
      "payout": "bi-weekly / on-demand",
      "drawdown": 10,
      "dailyDrawdown": 5,
      "evaluationTypes": [
        "instant",
        "1-step",
        "2-step",
        "3-step"
      ],
      "leverage": "1:100",
      "scalingPlan": true,
      "instantFunding": true,
      "timeLimit": "program-specific",
      "kYC": true,
      "cryptoTrading": false
    },
    "discounts": [
      {
        "code": "FUNDED40",
        "percent": 40,
        "firstPurchaseOnly": false,
        "phases": 0,
        "planType": "Alpha Direct",
        "validUntil": "2026-08-31T23:59:59Z",
        "validUntilRemark": "40% off Alpha Direct through 31 August 2026"
      },
      {
        "code": "ALPHA20",
        "percent": 20,
        "firstPurchaseOnly": false,
        "validUntil": "2026-08-31T23:59:59Z",
        "validUntilRemark": "20% off eligible Alpha One, Alpha Pro and Swing evaluations through 31 August 2026"
      }
    ],
    "pricing": [
      {
        "type": "1STEP",
        "name": "Alpha One",
        "accountSize": 100000,
        "fee": 497,
        "phases": 1,
        "leverage": "1:100",
        "feeRefundable": true,
        "profitSplit": 80,
        "timeLimit": "unlimited",
        "payoutFrequency": "bi-weekly",
        "phaseDetails": [
          {
            "profitTargetPercent": 10,
            "minProfitDays": 1
          }
        ],
        "dailyDrawdownPercent": 4,
        "maxDrawdownPercent": 6,
        "label": "Alpha One"
      },
      {
        "type": "2STEP",
        "name": "Alpha Pro",
        "accountSize": 100000,
        "fee": 497,
        "phases": 2,
        "leverage": "1:100",
        "feeRefundable": true,
        "profitSplit": 80,
        "timeLimit": "unlimited",
        "payoutFrequency": "bi-weekly",
        "phaseDetails": [
          {
            "profitTargetPercent": 8,
            "minProfitDays": 3
          },
          {
            "profitTargetPercent": 5,
            "minProfitDays": 3
          }
        ],
        "dailyDrawdownPercent": 5,
        "maxDrawdownPercent": 10,
        "label": "Alpha Pro"
      },
      {
        "type": "2STEP",
        "name": "Swing",
        "accountSize": 100000,
        "fee": 577,
        "phases": 2,
        "leverage": "1:100",
        "feeRefundable": true,
        "profitSplit": 80,
        "timeLimit": "unlimited",
        "payoutFrequency": "bi-weekly",
        "notes": "Allows holding positions overnight and over weekends",
        "phaseDetails": [
          {
            "profitTargetPercent": 8,
            "minProfitDays": 3
          },
          {
            "profitTargetPercent": 5,
            "minProfitDays": 3
          }
        ],
        "dailyDrawdownPercent": 5,
        "maxDrawdownPercent": 10,
        "label": "Swing"
      }
    ]
  },
  {
    "id": "blueberryfunded",
    "name": "Blueberry Funded",
    "logo": "/assets/logos/blueberryfunded/logo.svg",
    "affiliateLink": "/go/blueberryfunded",
    "features": {
      "maxFunding": 200000,
      "profitSplit": 80,
      "platforms": [
        "mt5",
        "tradelocker",
        "dxtrade"
      ],
      "payout": "bi-weekly",
      "drawdown": 10,
      "dailyDrawdown": 5,
      "evaluationTypes": [
        "1-step",
        "2-step",
        "3-step",
        "instant"
      ],
      "scalingPlan": false,
      "kYC": true,
      "instantFunding": true,
      "cryptoTrading": true,
      "restrictedCountries": [],
      "leverage": "varies by plan"
    },
    "discounts": [
      {
        "code": "PRIME40",
        "percent": 40,
        "firstPurchaseOnly": false,
        "planType": "Prime",
        "validUntilRemark": "Current featured Blueberry Funded promo for Prime challenges; verify at checkout"
      }
    ],
    "pricing": [
      {
        "accountSize": 100000,
        "fee": 550,
        "phases": 1,
        "type": "1STEP",
        "label": "1-Step Challenge",
        "name": "1-Step Challenge - 100K",
        "maxDrawdownPercent": 6,
        "dailyDrawdownPercent": 4,
        "leverage": "1:30",
        "profitSplit": 80,
        "phaseDetails": [
          {
            "profitTargetPercent": 10
          }
        ]
      },
      {
        "accountSize": 100000,
        "fee": 500,
        "phases": 2,
        "type": "2STEP",
        "label": "2-Step Challenge",
        "name": "2-Step Challenge - 100K",
        "maxDrawdownPercent": 10,
        "dailyDrawdownPercent": 5,
        "leverage": "1:50",
        "profitSplit": 80,
        "phaseDetails": [
          {
            "profitTargetPercent": 10
          },
          {
            "profitTargetPercent": 5
          }
        ]
      }
    ]
  },
  {
    "id": "cti",
    "name": "City Traders Imperium",
    "logo": "/assets/logos/cti/logo.svg",
    "affiliateLink": "/go/cti",
    "features": {
      "maxFunding": 4000000,
      "profitSplit": 80,
      "profitSplitNote": "Starts at 80% on challenge-funded accounts and can reach 100% through CTI VIP; Instant and Direct Funding start lower.",
      "platforms": [
        "mt5",
        "matchtrader"
      ],
      "payout": "from 7 days",
      "drawdown": 10,
      "dailyDrawdown": 5,
      "evaluationTypes": [
        "instant",
        "direct",
        "1-step",
        "2-step"
      ],
      "leverage": "1:30",
      "scalingPlan": true,
      "instantFunding": true,
      "timeLimit": "unlimited",
      "kYC": true,
      "cryptoTrading": true
    },
    "discounts": [],
    "pricing": [
      {
        "accountSize": 100000,
        "fee": 449,
        "phases": 1,
        "type": "1STEP",
        "label": "1-Step Challenge",
        "name": "CTI 1-Step",
        "maxDrawdownPercent": 5,
        "dailyDrawdownPercent": 5,
        "drawdownType": "trailing",
        "leverage": "1:30",
        "profitSplit": 80,
        "phaseDetails": [
          {
            "profitTargetPercent": 10
          }
        ]
      },
      {
        "accountSize": 100000,
        "fee": 519,
        "phases": 2,
        "type": "2STEP",
        "label": "2-Step Challenge",
        "name": "CTI 2-Step",
        "maxDrawdownPercent": 10,
        "dailyDrawdownPercent": 5,
        "drawdownType": "static",
        "leverage": "1:30",
        "profitSplit": 80,
        "phaseDetails": [
          {
            "profitTargetPercent": 10
          },
          {
            "profitTargetPercent": 5
          }
        ]
      }
    ]
  },
  {
    "id": "e8",
    "name": "E8 Markets",
    "logo": "/assets/logos/e8/logo.svg",
    "affiliateLink": "/go/e8",
    "features": {
      "maxFunding": 500000,
      "profitSplit": 100,
      "platforms": [
        "tradelocker",
        "ctrader",
        "matchtrader",
        "mt5"
      ],
      "payout": "daily/on-demand",
      "drawdown": 6,
      "dailyDrawdown": 4,
      "evaluationTypes": [
        "1-step"
      ],
      "leverage": "1:50",
      "scalingPlan": true,
      "instantFunding": false,
      "timeLimit": "unlimited",
      "kYC": true,
      "cryptoTrading": true
    },
    "discounts": [
      {
        "code": "E8",
        "percent": 25,
        "firstPurchaseOnly": false,
        "validUntilRemark": "Official evergreen code; current discount varies by product and can reach 40% on selected E8 Zero configurations"
      },
      {
        "code": "VIPER5",
        "percent": 5,
        "firstPurchaseOnly": false,
        "validUntilRemark": "PropViper affiliate code; E8 notes affiliate-code discounts can vary with current promotions"
      }
    ],
    "pricing": [
      {
        "accountSize": 100000,
        "fee": 488,
        "phases": 1,
        "type": "1STEP",
        "label": "E8 One",
        "name": "E8 One - Payout 80%",
        "maxDrawdownPercent": 6,
        "dailyDrawdownPercent": 4,
        "leverage": "1:30",
        "phaseDetails": [
          {
            "profitTargetPercent": 6
          }
        ]
      },
      {
        "accountSize": 100000,
        "fee": 488,
        "phases": 1,
        "type": "1STEP",
        "label": "E8 Pro",
        "name": "E8 Pro - Payout 80%",
        "maxDrawdownPercent": 8,
        "dailyDrawdownPercent": 2.5,
        "leverage": "1:30",
        "phaseDetails": [
          {
            "profitTargetPercent": 8
          }
        ]
      },
      {
        "accountSize": 100000,
        "fee": 260,
        "phases": 1,
        "type": "1STEP",
        "label": "E8 Signature",
        "name": "E8 Signature - Payout 80%",
        "maxDrawdownPercent": 3,
        "dailyDrawdownPercent": 0,
        "leverage": "1:30",
        "phaseDetails": [
          {
            "profitTargetPercent": 6
          }
        ]
      }
    ]
  },
  {
    "id": "for-traders",
    "name": "For Traders",
    "logo": "/assets/logos/for-traders/logo.svg",
    "affiliateLink": "/go/fortraders",
    "features": {
      "maxFunding": 300000,
      "profitSplit": 90,
      "profitSplitNote": "Up to 90% depending on program",
      "platforms": [
        "mt5",
        "ctrader",
        "tradelocker"
      ],
      "payout": "bi-weekly / on-demand",
      "drawdown": 6,
      "dailyDrawdown": 3,
      "evaluationTypes": [
        "instant",
        "1-step",
        "2-step",
        "3-step"
      ],
      "leverage": "1:125",
      "scalingPlan": true,
      "instantFunding": true,
      "timeLimit": "program-specific",
      "kYC": true,
      "cryptoTrading": true
    },
    "discounts": [
      {
        "code": "SUMMER2026",
        "percent": 25,
        "firstPurchaseOnly": false,
        "validUntilRemark": "Current For Traders summer promotion on eligible challenges; limited-time offer, verify at checkout"
      }
    ],
    "pricing": [
      {
        "accountSize": 100000,
        "fee": 529,
        "phases": 1,
        "type": "1STEP",
        "label": "One-Step Challenge $100K",
        "name": "One-Step Challenge 100K",
        "maxDrawdownPercent": 5,
        "dailyDrawdownPercent": 3,
        "leverage": "1:125",
        "phaseDetails": [
          {
            "profitTargetPercent": 9
          }
        ],
        "profitSplit": 80
      },
      {
        "accountSize": 100000,
        "fee": 549,
        "phases": 2,
        "type": "2STEP",
        "label": "Two-Step Challenge $100K",
        "name": "Two-Step Challenge 100K",
        "maxDrawdownPercent": 8,
        "dailyDrawdownPercent": 4,
        "leverage": "1:125",
        "phaseDetails": [
          {
            "profitTargetPercent": 8
          },
          {
            "profitTargetPercent": 5
          }
        ],
        "profitSplit": 80
      }
    ]
  },
  {
    "id": "fxify",
    "name": "FXIFY",
    "logo": "/assets/logos/fxify/logo.svg",
    "affiliateLink": "/go/fxify",
    "features": {
      "maxFunding": 400000,
      "profitSplit": 100,
      "platforms": [
        "mt5",
        "dxtrade",
        "tradingview"
      ],
      "payout": "on-demand / program-specific",
      "drawdown": 10,
      "dailyDrawdown": 4,
      "evaluationTypes": [
        "instant",
        "1-step",
        "2-step",
        "3-step",
        "lightning"
      ],
      "leverage": "1:50",
      "scalingPlan": true,
      "instantFunding": true,
      "timeLimit": "program-specific",
      "kycRequired": true,
      "cryptoTrading": true
    },
    "discounts": [
      {
        "code": "HOT20",
        "percent": 20,
        "firstPurchaseOnly": false,
        "validUntil": "2026-09-01T23:59:59Z",
        "validUntilRemark": "Official FXIFY summer offer; expires 1 September 2026"
      },
      {
        "code": "NEW30",
        "percent": 30,
        "firstPurchaseOnly": true,
        "planType": "2 Phase Pro",
        "validUntil": "2026-12-31T23:59:59Z",
        "validUntilRemark": "30% off 2 Phase Pro for new traders; official offer through 31 December 2026"
      }
    ],
    "pricing": [
      {
        "type": "1STEP",
        "name": "One Phase",
        "accountSize": 100000,
        "fee": 499,
        "phases": 1,
        "leverage": "1:50",
        "profitSplit": 90,
        "feeRefundable": true,
        "timeLimit": "unlimited",
        "phaseDetails": [
          {
            "profitTargetPercent": 10,
            "minProfitDays": 5
          }
        ],
        "dailyDrawdownPercent": 3,
        "maxDrawdownPercent": 6,
        "label": "One Phase"
      },
      {
        "type": "2STEP",
        "name": "Two Phase",
        "accountSize": 100000,
        "fee": 499,
        "phases": 2,
        "leverage": "1:50",
        "profitSplit": 90,
        "feeRefundable": true,
        "timeLimit": "unlimited",
        "phaseDetails": [
          {
            "profitTargetPercent": 10,
            "minProfitDays": 5
          },
          {
            "profitTargetPercent": 5,
            "minProfitDays": 5
          }
        ],
        "dailyDrawdownPercent": 4,
        "maxDrawdownPercent": 10,
        "label": "Two Phase"
      }
    ]
  },
  {
    "id": "hyrotrader",
    "name": "HyroTrader",
    "logo": "/assets/logos/hyrotrader/logo.svg?v=20260808",
    "affiliateLink": "/go/hyro",
    "features": {
      "maxFunding": 200000,
      "profitSplit": 90,
      "platforms": [
        "bybit",
        "cleo"
      ],
      "payout": "on-demand",
      "drawdown": 6,
      "dailyDrawdown": 4,
      "evaluationTypes": [
        "1-step",
        "2-step"
      ],
      "scalingPlan": true,
      "kYC": true,
      "instantFunding": false,
      "cryptoTrading": true,
      "restrictedCountries": [],
      "leverage": "1:100"
    },
    "discounts": [
      {
        "code": "VIPER10",
        "percent": 10,
        "firstPurchaseOnly": false,
        "phases": null,
        "validUntil": null,
        "validUntilRemark": null
      }
    ],
    "pricing": [
      {
        "accountSize": 100000,
        "fee": 579,
        "phases": 1,
        "type": "1STEP",
        "label": "One-Step Challenge",
        "name": "One-Step - 100,000 USDT",
        "maxDrawdownPercent": 6,
        "dailyDrawdownPercent": 4,
        "leverage": "1:100",
        "profitSplit": 90,
        "phaseDetails": []
      }
    ]
  },
  {
    "id": "onefunded",
    "name": "OneFunded",
    "logo": "/assets/logos/onefunded/logo.svg",
    "affiliateLink": "/go/onefunded",
    "features": {
      "maxFunding": 1000000,
      "profitSplit": 80,
      "profitSplitNote": "80% standard; up to 90% on selected programs/add-ons",
      "platforms": [
        "mt5",
        "ctrader",
        "tradelocker"
      ],
      "payout": "Every 14 days; 7-day option available",
      "drawdown": 10,
      "dailyDrawdown": 5,
      "evaluationTypes": [
        "instant",
        "1-step",
        "2-step"
      ],
      "scalingPlan": true,
      "kYC": true,
      "instantFunding": true,
      "cryptoTrading": true,
      "restrictedCountries": [
        "AF",
        "BY",
        "CF",
        "CU",
        "CD",
        "ER",
        "GW",
        "IR",
        "IQ",
        "LB",
        "KP",
        "RU",
        "SS",
        "SD",
        "SO",
        "SY",
        "YE",
        "ZW"
      ],
      "leverage": "FX 1:100; indices/commodities 1:30; crypto 1:2"
    },
    "discounts": [
      {
        "code": "VIPER25",
        "percent": 25,
        "firstPurchaseOnly": false,
        "phases": null,
        "validUntil": null,
        "validUntilRemark": null
      }
    ],
    "pricing": [
      {
        "accountSize": 100000,
        "fee": 349,
        "phases": 2,
        "type": "2STEP",
        "label": "Value 2-Step",
        "name": "Value - $100,000",
        "maxDrawdownPercent": 8,
        "dailyDrawdownPercent": 4,
        "leverage": "Up to 1:100",
        "profitSplit": 80,
        "payout": "Every 14 days",
        "consistencyPercent": null,
        "riskPerTradeIdeaPercent": 3,
        "refundableFee": true,
        "phaseDetails": [
          {
            "profitTargetPercent": 8,
            "minProfitDays": 4
          },
          {
            "profitTargetPercent": 6,
            "minProfitDays": 4
          }
        ]
      },
      {
        "accountSize": 100000,
        "fee": 469,
        "phases": 2,
        "type": "2STEP",
        "label": "Core 2-Step",
        "name": "Core - $100,000",
        "maxDrawdownPercent": 10,
        "dailyDrawdownPercent": 5,
        "leverage": "Up to 1:100",
        "profitSplit": 90,
        "payout": "Every 14 days",
        "consistencyPercent": null,
        "riskPerTradeIdeaPercent": 3,
        "refundableFee": true,
        "phaseDetails": [
          {
            "profitTargetPercent": 8,
            "minProfitDays": 3
          },
          {
            "profitTargetPercent": 5,
            "minProfitDays": 3
          }
        ]
      },
      {
        "accountSize": 100000,
        "fee": 499,
        "phases": 1,
        "type": "1STEP",
        "label": "Flash 1-Step",
        "name": "Flash - $100,000",
        "maxDrawdownPercent": 6,
        "dailyDrawdownPercent": 4,
        "leverage": "Up to 1:100",
        "profitSplit": 90,
        "payout": "Every 14 days",
        "consistencyPercent": 50,
        "riskPerTradeIdeaPercent": 3,
        "refundableFee": true,
        "phaseDetails": [
          {
            "profitTargetPercent": 10,
            "minProfitDays": 1
          }
        ]
      }
    ]
  },
  {
    "id": "ttp",
    "name": "The Trading Pit",
    "logo": "/assets/logos/ttp/logo.svg",
    "affiliateLink": "/go/ttp",
    "features": {
      "maxFunding": 400000,
      "profitSplit": 80,
      "platforms": [
        "mt4",
        "mt5",
        "ctrader"
      ],
      "payout": "bi-weekly",
      "drawdown": 10,
      "dailyDrawdown": 5,
      "evaluationTypes": [
        "1-step",
        "2-step"
      ],
      "leverage": "varies",
      "scalingPlan": true,
      "instantFunding": false,
      "timeLimit": "varies by product",
      "kYC": true,
      "cryptoTrading": true
    },
    "discounts": [
      {
        "code": "VIPER",
        "percent": 10,
        "firstPurchaseOnly": false,
        "validUntil": null,
        "validUntilRemark": null
      }
    ],
    "pricing": [
      {
        "type": "1STEP",
        "name": "Prime CFD One-Step",
        "accountSize": 100000,
        "fee": 569,
        "phases": 1,
        "leverage": "1:50",
        "profitSplit": 80,
        "feeRefundable": true,
        "timeLimit": "unlimited",
        "payoutFrequency": "bi-weekly (min $100)",
        "phaseDetails": [
          {
            "profitTargetPercent": 10,
            "minProfitDays": 5
          }
        ],
        "dailyDrawdownPercent": 4,
        "maxDrawdownPercent": 7,
        "label": "Prime One-Step"
      },
      {
        "type": "2STEP",
        "name": "Prime CFD Two-Step",
        "accountSize": 100000,
        "fee": 569,
        "phases": 2,
        "leverage": "1:50",
        "profitSplit": 80,
        "feeRefundable": true,
        "timeLimit": "unlimited",
        "payoutFrequency": "bi-weekly (min $100)",
        "phaseDetails": [
          {
            "profitTargetPercent": 8,
            "minProfitDays": 5
          },
          {
            "profitTargetPercent": 5,
            "minProfitDays": 5
          }
        ],
        "dailyDrawdownPercent": 5,
        "maxDrawdownPercent": 10,
        "label": "Prime Two-Step"
      }
    ]
  },
  {
    "id": "tradingplus",
    "name": "TradingPLUS",
    "logo": "/assets/logos/tradingplus/logo.svg",
    "affiliateLink": "/go/tradingplus",
    "features": {
      "maxFunding": 200000,
      "profitSplit": 80,
      "platforms": [
        "mt5"
      ],
      "payout": "bi-weekly",
      "drawdown": 10,
      "dailyDrawdown": 5,
      "evaluationTypes": [
        "2-step"
      ],
      "scalingPlan": false,
      "kYC": true,
      "instantFunding": false,
      "cryptoTrading": false,
      "restrictedCountries": [
        "United States",
        "China",
        "Vietnam"
      ],
      "leverage": "1:100"
    },
    "discounts": [
      {
        "code": "VIPER",
        "percent": 10,
        "firstPurchaseOnly": true,
        "phases": 2,
        "validUntilRemark": null
      }
    ],
    "pricing": [
      {
        "accountSize": 100000,
        "fee": 549,
        "phases": 2,
        "type": "2STEP",
        "label": "2-Step Challenge",
        "name": "Challenge - $100k",
        "maxDrawdownPercent": 10,
        "dailyDrawdownPercent": 5,
        "leverage": "1:100",
        "profitSplit": 80,
        "phaseDetails": []
      }
    ]
  },
  {
    "id": "wmt",
    "name": "WeMasterTrade",
    "logo": "/assets/logos/wmt/logo.svg",
    "affiliateLink": "/go/wmt",
    "features": {
      "maxFunding": 200000,
      "profitSplit": 90,
      "profitSplitNote": "Up to 90%, depending on package and rule compliance",
      "platforms": [
        "mt5"
      ],
      "payout": "Package-specific",
      "drawdown": 10,
      "dailyDrawdown": 5,
      "evaluationTypes": [
        "instant",
        "2-step"
      ],
      "timeLimit": "Package-specific",
      "scalingPlan": true,
      "kYC": true,
      "instantFunding": true,
      "cryptoTrading": true,
      "restrictedCountries": [],
      "leverage": "Up to 1:100"
    },
    "discounts": [
      {
        "code": "VIPER25",
        "percent": 25,
        "firstPurchaseOnly": true,
        "validUntilRemark": "Exclusive 25% off – First Purchase Only"
      }
    ],
    "pricing": [
      {
        "accountSize": 100000,
        "fee": 320,
        "phases": 2,
        "type": "2STEP",
        "label": "2-Phase Challenge",
        "name": "2-Phase 100K",
        "maxDrawdownPercent": 10,
        "dailyDrawdownPercent": 5,
        "leverage": "1:100",
        "profitSplit": 80,
        "phaseDetails": [
          {
            "profitTargetPercent": 8
          },
          {
            "profitTargetPercent": 6
          }
        ]
      }
    ]
  }
] as const;

export default homepageFirmData;
